import React from "react";
import { Button, Input } from "reactstrap";
import DataTable from "react-data-table-component";
import { FiTrash2 } from "react-icons/fi";

const DynamicTable = ({
    columns,
    data,
    onRowDelete,
    customStyles,
    isPagination
}) => {

    // Define action columns dynamically, if onRowDelete or other actions are provided
    const actionColumn = onRowDelete
        ? {
            name: "Actions",
            cell: (row, index) => (
                <Button color="link" onClick={() => onRowDelete(index)}>
                    <FiTrash2 size={20} color="#e70000" />
                </Button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        }
        : null;

    // Combine columns with action column (if any)
    const finalColumns = actionColumn ? [...columns, actionColumn] : columns;

    return (
        <div>
            <DataTable
                columns={finalColumns}
                data={data}
                noHeader
                pagination={isPagination}
                highlightOnHover
                customStyles={customStyles || defaultStyles} // Use default styles if not provided
            />
        </div>
    );
};

// Default custom styles for react-data-table-component
const defaultStyles = {
    headRow: {
        style: {
            backgroundColor: '#F2F2F2',
        },
    },
    rows: {
        style: {
            minHeight: "72px",
        },
    },
    headCells: {
        style: {
            paddingLeft: "8px",
            paddingRight: "8px",
        },
    },
    cells: {
        style: {
            paddingLeft: "8px",
            paddingRight: "8px",
        },
    },
};

export default DynamicTable;
